import ActionTypeZona from "../ActionTypeZona";
// import {ModosOp} from '../../Constantes'
// import Estado from '../EstadoDialogoClienteAFacturar'

export default class CargaDeErroresDelDominioAlCrearZona extends ActionTypeZona {
    ejecutar(estado, nuevoEstado) {
        for (const property in nuevoEstado.error) {
            nuevoEstado.error[property] = false;
        }

        this.payload.errores.forEach((error) => {
            nuevoEstado.error[error.key] = true;
        });

        nuevoEstado.flag.procesandoComandoCrear=false
        nuevoEstado.flag.procesandoComando = false;
        return nuevoEstado;
    }
}
